export default {
  title: 'Tilaukset',
};
